import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "getInsuranceProjects";
export var useGetInsuranceProjects = function () {
    var dispatch = useDispatch();
    var loadingProjects = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var projects = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var errorProjects = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var totalItems = useSelector(function (state) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.pagingInfo) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) === null || _c === void 0 ? void 0 : _c.totalItems) !== null && _d !== void 0 ? _d : 0; });
    var fetchProjects = function (_a) {
        var enable = _a.enable, page = _a.page, limit = _a.limit, projectType = _a.projectType, sponsorId = _a.sponsorId, description = _a.description;
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/asg/Api/V1/Project",
            queryParams: {
                enable: enable,
                page: page,
                limit: limit,
                projectType: projectType,
                sponsorId: sponsorId,
                description: description,
            },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return { fetchProjects: fetchProjects, projects: projects, totalItems: totalItems, loadingProjects: loadingProjects, errorProjects: errorProjects };
};
